import { memo } from 'react'

import { Text } from '@cash-me/react-components'
import NextImage from 'next/image'

import { Col, Grid } from 'components/grid'

import { leaders, PHOTO_HEIGHT, PHOTO_WIDTH } from './data'
import * as S from './styles'

const Leadership = memo(() => (
  <S.Section>
    <Grid col={{ phone: 1, tablet: 1 }}>
      <Col col={{ desktop: 10 }} start={{ desktop: 2 }}>
        <S.TitleWrapper>
          <Text as="h2" size="heading2" weight="medium" color="var(--colors-neutral-text-contrast-default)">
            Conheça nossa{' '}
            <Text as="span" size="heading2" weight="medium" color="var(--colors-cyan-background-pressed)">
              liderança
            </Text>
          </Text>
        </S.TitleWrapper>
      </Col>

      <Col col={{ desktop: 10 }} start={{ desktop: 2 }}>
        <S.Cards>
          {leaders.map(({ id, name, role, photo }) => (
            <S.Card key={id}>
              <NextImage
                src={photo}
                alt=""
                width={PHOTO_WIDTH}
                height={PHOTO_HEIGHT}
                sizes="(min-width: 1240px) 25vw, 50vw"
              />
              <S.Scrim aria-hidden />
              <S.Info>
                <Text size="heading4" color="var(--colors-neutral-text-contrast-default)">
                  {name}
                </Text>
                <Text size="bodySmall" weight="bold" color="var(--colors-cyan-background-pressed)">
                  {role}
                </Text>
              </S.Info>
            </S.Card>
          ))}
        </S.Cards>
      </Col>
    </Grid>
  </S.Section>
))

Leadership.displayName = 'Leadership'

export default Leadership
